import { useEffect, useRef, useState } from "react"
import { authServices } from "../../APIServices/UserData/authServices";
import { useApp } from "../../APIHelpers/AppContext";

const AutoLogout = () => {
    const {
        auth,
        currentUserData,
    } = useApp();
    const [idleTime, setIdleTime] = useState(null);
    const timerRef = useRef(null)
    const intervalRef = useRef(null)
    const [remainingTime, setRemainingTime] = useState(null)
    useEffect(() => {
        if (!currentUserData?.sessionExpiry) return;
        let minutes = 60;
        if (currentUserData.sessionExpiry === "1m") minutes = 1;
        else if (currentUserData.sessionExpiry === "1h") minutes = 60;
        else if (currentUserData.sessionExpiry === "30m") minutes = 30;
        const calculatedIdleTime = minutes * 60 * 1000;
        setIdleTime(calculatedIdleTime);
        setRemainingTime(calculatedIdleTime / 1000)
    }, [currentUserData]);

    const bc = useRef(new BroadcastChannel("auth_channel")).current
    const handleLogout = async () => {
        await authServices.logout(auth)
    }
    const resetTimer = () => {
        if (timerRef.current) clearTimeout(timerRef.current)
        if (intervalRef.current) clearInterval(intervalRef.current)
        setRemainingTime(idleTime / 1000)
        intervalRef.current = setInterval(() => {
            setRemainingTime((prev) => {
                console.log("Remaining time (s):", prev - 1)
                return prev - 1
            })
        }, 1000)
        timerRef.current = setTimeout(() => handleLogout(), idleTime)
    }
    useEffect(() => {
        if (!auth) return
        if (!idleTime) return;
        const events = ["mousemove", "keydown", "scroll", "click"]
        events.forEach((e) => window.addEventListener(e, resetTimer))
        bc.onmessage = (e) => {
            if (e.data === "logout") {
                clearTimeout(timerRef.current)
                clearInterval(intervalRef.current)
            }
        }
        resetTimer()
        return () => {
            events.forEach((e) => window.removeEventListener(e, resetTimer))
            clearTimeout(timerRef.current)
            clearInterval(intervalRef.current)
            bc.close()
        }
    }, [idleTime])
    return null
}
export default AutoLogout
